<template>
<el-dialog :title="!dataForm.id ? '新增' : '修改'" width="50%" :append-to-body="true" :close-on-click-modal="false" :visible.sync="view.visible">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()" label-width="0px" class="code-type-dialog-form" size="small">
        <div class="des_box">
            <el-descriptions class="margin-top" :column="1" size="small" border style="margin-bottom: 15px;">
                <el-descriptions-item label="工作内容" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="workContent" style="margin-bottom: 0;">
                        <el-input v-model="dataForm.workContent" placeholder="工作内容"></el-input>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="责任部门" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="chargeDept" style="margin-bottom: 0;">
                        <el-input v-model="dataForm.chargeDept" placeholder="责任部门"></el-input>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="日期" :label-style="getStyle()">
                    <el-form-item prop="workDate" style="margin-bottom: 0;">
                        <el-date-picker v-model="dataForm.workDate" type="date" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间">
                        </el-date-picker>
                    </el-form-item>
                </el-descriptions-item>
            </el-descriptions>
        </div>
    </el-form>
    <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="view.visible = false">
            <span class="font-12 iconfont myicon-quxiao1"></span>&nbsp;取消
        </el-button>
        <el-button size="small" type="primary" plain @click="dataFormSubmit()" :loading="loading">
            <span class="font-12 iconfont myicon-tongguo"></span>&nbsp;保存
        </el-button>
    </span>
</el-dialog>
</template>

<script>
import {
    getBiddingById,
    createBidding,
    editBidding
} from "@/controller/tech";
import {
    setLoading
} from "@/utils/index";
export default {
    data() {
        return {
            loading: false,
            view: {
                visible: false,
                conheight: {
                    height: this.$store.state.common.documentClientDefaultHeight *
                        0.9 -
                        410 +
                        "px",
                    "overflow-y": "auto",
                },
            },
            viewData: {},
            dataForm: {
                id: 0,
                workContent: "",
                workDate: "",
                chargeDept: "",
                technicalId: "",
            },
            // 开始
            dataRule: {},
        };
    },
    methods: {
        init(id, technicalId) {
            this.dataForm.id = id || 0;
            this.dataForm.technicalId = technicalId;
            this.view.visible = true;
            this.loading = false
            this.$nextTick(() => {
                this.$refs["dataForm"].resetFields();
                if (this.dataForm.id) {
                    getBiddingById({}, this.dataForm.id).then((data) => {
                        if (data && data.code === "00") {
                            this.dataForm = data.body;
                        }
                    });
                }
            });
        },
        // 表单提交
        dataFormSubmit() {
            this.loading = true
            setLoading()
            this.$refs["dataForm"].validate((valid) => {
                if (valid) {
                    let biddingParams = {
                        id: this.dataForm.id || undefined,
                        workContent: this.dataForm.workContent,
                        workDate: this.dataForm.workDate,
                        chargeDept: this.dataForm.chargeDept,
                        technicalId: this.dataForm.technicalId,
                    };
                    if (this.dataForm.id) {
                        editBidding(biddingParams)
                            .then((data) => {
                                if (data && data.code === "00") {
                                    this.$message({
                                        message: "操作成功",
                                        type: "success",
                                        duration: 1500,
                                        onClose: () => {
                                            this.view.visible = false;
                                            this.$emit(
                                                "refreshBiddingDataList"
                                            );
                                        },
                                    });
                                } else {
                                    this.$message.error(data.msg);
                                }
                            })
                            .catch((error) => {
                                console.log(error);
                            });
                    } else {
                        createBidding(biddingParams)
                            .then((data) => {
                                if (data && data.code === "00") {
                                    this.$message({
                                        message: "操作成功",
                                        type: "success",
                                        duration: 1500,
                                        onClose: () => {
                                            this.view.visible = false;
                                            this.$emit(
                                                "refreshBiddingDataList"
                                            );
                                        },
                                    });
                                } else {
                                    this.$message.error(data.msg);
                                }
                            })
                            .catch((error) => {
                                console.log(error);
                            });
                    }
                }
            });
        },
        getStyle() {
            return 'width: 90px; text-align: right'
        },
        getStyle2() {
            return 'width: 273.5px;'
        },
    },
};
</script>

<style lang="scss" scoped>
.el-dialog__body {
    .code-type-dialog-form {
        width: 100%;
    }
}
</style>
